import { useState } from 'react';
import { fetchJson } from '../../../helpers/index.js';

const UNEXPECTED_ERROR = () => ({ base: [{ message: I18n.t('unexpected_error') }] });

// POSTs JSON and tracks the saving state and validation errors returned by the server
export default function usePostJson() {
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState({});

  const post = async (path, body = {}) => {
    setSaving(true);
    setErrors({});

    try {
      return await fetchJson(path, {
        method: 'POST',
        body: JSON.stringify(body),
        rejectBadRequest: true,
      });
    } catch (response) {
      const data = await response.json?.().catch(() => null);
      setErrors(data?.errors || UNEXPECTED_ERROR());
      return null;
    } finally {
      setSaving(false);
    }
  };

  return { post, saving, errors };
}
